/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrutturaFunzioneFromJSON, StrutturaFunzioneToJSON, } from './StrutturaFunzione';
/**
 * Check if a given object implements the ProjectLightInfoDto interface.
 */
export function instanceOfProjectLightInfoDto(value) {
    return true;
}
export function ProjectLightInfoDtoFromJSON(json) {
    return ProjectLightInfoDtoFromJSONTyped(json, false);
}
export function ProjectLightInfoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'intranetId': json['intranetId'] == null ? undefined : json['intranetId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'strutturaFunzione': json['strutturaFunzione'] == null ? undefined : StrutturaFunzioneFromJSON(json['strutturaFunzione']),
        'invoicedIssue': json['invoicedIssue'] == null ? undefined : json['invoicedIssue'],
        'denominazioneResponsabileProgetto': json['denominazioneResponsabileProgetto'] == null ? undefined : json['denominazioneResponsabileProgetto'],
        'totAmount': json['totAmount'] == null ? undefined : json['totAmount'],
        'actualRevenue': json['actualRevenue'] == null ? undefined : json['actualRevenue'],
        'denominazioneStatoProgetto': json['denominazioneStatoProgetto'] == null ? undefined : json['denominazioneStatoProgetto'],
        'importo': json['importo'] == null ? undefined : json['importo'],
        'denominazioneAzienda': json['denominazioneAzienda'] == null ? undefined : json['denominazioneAzienda'],
    };
}
export function ProjectLightInfoDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'projectId': value['projectId'],
        'intranetId': value['intranetId'],
        'projectName': value['projectName'],
        'strutturaFunzione': StrutturaFunzioneToJSON(value['strutturaFunzione']),
        'invoicedIssue': value['invoicedIssue'],
        'denominazioneResponsabileProgetto': value['denominazioneResponsabileProgetto'],
        'totAmount': value['totAmount'],
        'actualRevenue': value['actualRevenue'],
        'denominazioneStatoProgetto': value['denominazioneStatoProgetto'],
        'importo': value['importo'],
        'denominazioneAzienda': value['denominazioneAzienda'],
    };
}
